const termsConditions = {
    title: "Terms & Conditions",
    slug: "terms-and-conditions",
    lastUpdated: "27 July 2026",

    heroTitle: "Terms & Conditions",

    heroDescription:
        "Please read these Terms and Conditions carefully before using the Horyzen Technologies website or engaging with any of our services. By accessing our website, you agree to comply with these Terms.",

    sections: [
        {
            id: "introduction",
            title: "Introduction",
            paragraphs: [
                'Welcome to Horyzen Technologies ("Company", "we", "us", or "our"). These Terms and Conditions ("Terms") govern your access to and use of our website https://horyzen.in ("Site") and any IT services, consulting, software development, internship programs, or related offerings described on the Site (collectively, the "Services").',
                "By accessing or using our website or Services, you acknowledge that you have read, understood, and agreed to be bound by these Terms. If you do not agree with any part of these Terms, please discontinue the use of our website immediately."
            ]
        },

        {
            id: "about-us",
            title: "About Us",
            paragraphs: [
                "Horyzen Technologies is an IT services and consulting company dedicated to delivering innovative technology solutions, software development, web and mobile application development, AI solutions, digital transformation, training, internships, and technical consulting.",
                "The information presented on this website is intended to provide a general overview of our services and may be updated, modified, or discontinued without prior notice."
            ]
        },

        {
            id: "site-usage",
            title: "Use of the Website",
            paragraphs: [
                "You agree to use this website only for lawful purposes and in a manner that does not infringe the rights of others or restrict anyone else's use of the Site.",
                "You must not misuse our website or attempt to interfere with its normal operation."
            ],

            list: [
                "Attempting to gain unauthorized access to the website, servers, databases, or connected networks.",
                "Uploading or distributing viruses, malware, ransomware, or any malicious software.",
                "Using bots, crawlers, scrapers, or automated systems without prior written permission.",
                "Attempting to disrupt website functionality through attacks or excessive requests.",
                "Copying, reproducing, or redistributing website content without authorization.",
                "Providing false information or impersonating another individual or organization."
            ]
        },

        {
            id: "services",
            title: "Services and Client Engagements",
            paragraphs: [
                "Information available on this website is provided for informational purposes only and does not constitute a legally binding offer.",
                "Any professional IT services, consulting engagements, software development projects, internship programs, or custom solutions provided by Horyzen Technologies shall be governed by a separate proposal, Statement of Work (SOW), agreement, contract, or engagement letter.",
                "Where such agreements exist, their terms shall prevail over these website Terms for that specific engagement."
            ]
        },

        {
            id: "intellectual-property",
            title: "Intellectual Property",
            paragraphs: [
                "Unless otherwise stated, all content available on this website, including but not limited to text, graphics, logos, icons, illustrations, source code, designs, documents, software, videos, and other materials, is the exclusive property of Horyzen Technologies or its licensors.",
                "These materials are protected under applicable copyright, trademark, and intellectual property laws.",
                "You may not reproduce, modify, publish, distribute, transmit, display, or create derivative works from any website content without prior written permission from Horyzen Technologies, except for normal personal and non-commercial browsing."
            ]
        },

        {
            id: "third-party-links",
            title: "Third-Party Links",
            paragraphs: [
                "Our website may contain links to third-party websites, platforms, or services for your convenience.",
                "These third-party websites operate independently and are not controlled by Horyzen Technologies.",
                "We do not endorse or accept responsibility for their content, policies, security practices, products, or services. Users access third-party websites entirely at their own risk."
            ]
        },

        {
            id: "disclaimer",
            title: "Disclaimer of Warranties",
            paragraphs: [
                'The website and all Services are provided on an "AS IS" and "AS AVAILABLE" basis.',
                "To the maximum extent permitted by applicable law, Horyzen Technologies disclaims all warranties, whether express or implied, including warranties of merchantability, fitness for a particular purpose, title, and non-infringement.",
                "We do not guarantee that the website will always remain uninterrupted, secure, error-free, or free from harmful components."
            ]
        },

        {
            id: "limitation-liability",
            title: "Limitation of Liability",
            paragraphs: [
                "To the fullest extent permitted by law, Horyzen Technologies shall not be liable for any direct, indirect, incidental, consequential, special, exemplary, or punitive damages arising from the use of or inability to use our website or Services.",
                "This limitation applies even if Horyzen Technologies has been advised of the possibility of such damages.",
                "Nothing contained in these Terms shall exclude any liability that cannot legally be excluded under applicable law."
            ]
        },

        {
            id: "indemnification",
            title: "Indemnification",
            paragraphs: [
                "You agree to indemnify, defend, and hold harmless Horyzen Technologies, its directors, employees, interns, consultants, affiliates, partners, and licensors from and against any claims, damages, liabilities, losses, costs, or legal expenses arising from:",
            ],

            list: [
                "Your violation of these Terms.",
                "Your misuse of the website or Services.",
                "Your infringement of any intellectual property or legal rights.",
                "Any unlawful activities conducted through your use of the website."
            ]
        },

        {
            id: "governing-law",
            title: "Governing Law and Jurisdiction",
            paragraphs: [
                "These Terms shall be governed and interpreted in accordance with the laws of the Republic of India.",
                "Any disputes arising from these Terms or your use of the website shall be subject to the exclusive jurisdiction of the courts located in Pune, Maharashtra, India."
            ]
        },

        {
            id: "changes",
            title: "Changes to These Terms",
            paragraphs: [
                "Horyzen Technologies reserves the right to modify, update, or replace these Terms at any time without prior notice.",
                "Any revisions become effective immediately after publication on this website.",
                "Continued use of the website after changes have been posted constitutes your acceptance of the revised Terms."
            ]
        },

        {
            id: "contact",
            title: "Contact Us",
            paragraphs: [
                "If you have any questions, concerns, or requests regarding these Terms and Conditions, please contact us using the information below."
            ],

            contact: {
                company: "Horyzen Technologies",
                email: "info@horyzen.in",
                website: "https://horyzen.in"
            }
        }
    ]
};

export default termsConditions;